/**
 * Die Monats-Trennzeile der Notizen-Liste.
 *
 * Herausgelöst aus `Pages/Apartments/Notes.vue` (Auftrag Luca, 2026-08-17),
 * weil die Käuferseite (`Pages/Client/Apartment/Notes.vue`) dieselbe
 * Gliederung zeigt. Reine Funktion statt Mixin: die Übersetzung kommt als
 * Argument herein, damit sie ohne Vue-Instanz prüfbar bleibt.
 *
 * Liefert `null`, wenn der Eintrag im selben Monat liegt wie sein Vorgänger —
 * dann steht über ihm keine Trennzeile.
 *
 * @param {(key: string) => string} t   Übersetzer, üblicherweise `this.$t`
 * @param {Array<{date?: string}>} notes  Die Liste in Anzeige-Reihenfolge
 * @param {number} index
 * @returns {string|null}
 */
export function noteMonthLabel(t, notes, index) {
    const entry = notes[index];

    if (!entry || !entry.date) {
        return null;
    }

    const key = entry.date.slice(0, 7);
    const previous = index > 0 ? (notes[index - 1].date || "").slice(0, 7) : null;

    if (key === previous) {
        return null;
    }

    const [year, month] = key.split("-");

    return t("apartments.noteMonths." + month) + " " + year;
}
